import { render, staticRenderFns } from "./PBXPanel.vue?vue&type=template&id=2f6998d0&scoped=true&"
import script from "./PBXPanel.vue?vue&type=script&lang=js&"
export * from "./PBXPanel.vue?vue&type=script&lang=js&"
import style0 from "./PBXPanel.vue?vue&type=style&index=0&id=2f6998d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6998d0",
  null
  
)

export default component.exports